export const GET_FAVOURITES = 'GET_FAVOURITES';
export const GET_FAVOURITES_ERROR = 'GET_FAVOURITES_ERROR';
export const GET_FAVOURITES_SUCCESS = 'GET_FAVOURITES_SUCCESS';

export const SET_FAVOURITES = 'SET_FAVOURITES';
export const SET_FAVOURITES_ERROR = 'SET_FAVOURITES_ERROR';
export const SET_FAVOURITES_SUCCESS = 'SET_FAVOURITES_SUCCESS';

export const SET_USER_DATA = 'SET_USER_DATA';

export const USER_LOG_OUT = 'USER_LOG_OUT';

export const ADD_FAVOURITE = 'ADD_FAVOURITE';
export const ADD_FAVOURITE_SUCCESS = 'ADD_FAVOURITE_SUCCESS';
export const ADD_FAVOURITE_ERROR = 'ADD_FAVOURITE_ERROR';

export const REMOVE_FAVOURITE = 'REMOVE_FAVOURITE';
export const REMOVE_FAVOURITE_SUCCESS = 'REMOVE_FAVOURITE_SUCCESS';
export const REMOVE_FAVOURITE_ERROR = 'REMOVE_FAVOURITE_ERROR';


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/user/constants.ts